const MEXICAN_STRIPE_ACCOUNTS = ['Famio - MX 2']

export const isMexicanStripeAccount = (accountName: string) =>
  MEXICAN_STRIPE_ACCOUNTS.includes(accountName)
